module.exports = __webpack_public_path__ + "static/media/TitlesPage.0b6f3698.png";